/* Motion is optional; text and decorative rules stay visible without JavaScript. */
(() => {
  const motion=matchMedia('(prefers-reduced-motion: reduce)');
  const stories=new Set();
  let queued=false;
  const observer='IntersectionObserver' in window ? new IntersectionObserver(entries=>{
    entries.forEach(entry=>{if(entry.isIntersecting){entry.target.classList.add('vnk-story-drawn');observer.unobserve(entry.target);}});
  },{threshold:.35}) : null;
  function init() {
    document.querySelectorAll('.vnk-footer-story').forEach(element=>{
      if(stories.has(element))return;
      stories.add(element);
      if(observer&&!motion.matches){element.classList.add('vnk-story-ready');observer.observe(element);}
    });
    update();
  }
  function update() {
    queued=false;
    for(const story of stories)if(!story.isConnected){observer?.unobserve(story);stories.delete(story);}
  }
  const schedule=()=>{if(!queued){queued=true;requestAnimationFrame(update);}};
  window.addEventListener('scroll',schedule,{passive:true});
  window.addEventListener('resize',schedule,{passive:true});
  motion.addEventListener('change',()=>{
    if(motion.matches){stories.forEach(story=>story.classList.add('vnk-story-drawn'));}
    schedule();
  });
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init,{once:true});else init();
  document.addEventListener('shopify:section:load',init);
  document.addEventListener('shopify:section:unload',schedule);
})();
